import Hero from "../home-components/Hero";
import Projects from "../home-components/Projects";
import Team from "../home-components/Team";
import ContactForm from "../base-components/ContactForm";
import {useEffect, useState} from "react";


function Home() {
    const [isContactFormOpen, setIsContactFormOpen] = useState(false);

    const scrollToContact = () => {
        const el = document.getElementById("contact-form");
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const handleScroll = () => {
        if (isContactFormOpen) {
            scrollToContact()
        }
        else {
            setIsContactFormOpen(true);
        }
    }

    useEffect(() => {
        if (isContactFormOpen) {
            scrollToContact()
        }
    }, [isContactFormOpen])

    return (
        <main className="overflow-x-hidden">
            <Hero />
            <Projects onChangeForm={handleScroll} />
            <Team />
            <div className="bg-dark">
                {isContactFormOpen && <ContactForm projectName={"4AI"}/>}
            </div>
        </main>
    );
}

export default Home;

